import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../context";

export default function ByDefaultSection() {
	const { actions } = useContext(Context);
	const { translate } = useLocales();
	return (
		<Stack sx={{ mt: 4 }} gap={2}>
			<LoadingButton onClick={actions.showRestoreDialog}>
				{translate("customization.reset_values")}
			</LoadingButton>
		</Stack>
	);
}
